import { cn } from "@/lib/utils";

const MAP = {
  open: "bg-blue-50 text-blue-700 border-blue-200",
  toegewezen: "bg-amber-50 text-amber-700 border-amber-200",
  afgerond: "bg-green-50 text-green-700 border-green-200",
  geaccepteerd: "bg-green-50 text-green-700 border-green-200",
  geweigerd: "bg-red-50 text-red-700 border-red-200",
  in_afwachting: "bg-blue-50 text-blue-700 border-blue-200",
  niet_gekozen: "bg-slate-100 text-slate-500 border-slate-200",
};

const LABEL = {
  open: "Open",
  toegewezen: "Toegewezen",
  afgerond: "Afgerond",
  geaccepteerd: "Geaccepteerd",
  geweigerd: "Geweigerd",
  in_afwachting: "In afwachting",
  niet_gekozen: "Niet gekozen",
};

export default function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={cn(
        "inline-flex items-center rounded-sm border px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide",
        MAP[status] || "bg-slate-100 text-slate-600 border-slate-200"
      )}
    >
      {LABEL[status] || status}
    </span>
  );
}
